var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('flatpickr',{staticClass:"date-time",class:{ 'has-placeholder': _vm.placeholder, 'has-value': _vm.value },attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"required":_vm.required,"config":_vm.totalConfig},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }